module.exports = __webpack_public_path__ + "static/media/difdisplay-webfont.57a6ad65.svg";